import { configManagerCloudServicesApi } from './config-manager-cloud-services/configManagerCloudServicesApi';
import { dataManagerServiceApi } from './data-manager/dataManagerServiceApi';
import { jobManagerServiceApi } from './job-manager/jobManagerServiceApi';
import { leadGenServiceApi } from './leadgen/leadGenServiceApi';
import { n8nWebhookApi } from './n8n/n8nWebhookApi';
import { emptyRagServerServicesApi } from './rag-server/emptyRagServerServicesApi';
import { emptySpeak2MeServicesApi } from './speak2me/emptySpeak2MeServicesApi';

export const apiReducers = {
  [configManagerCloudServicesApi.reducerPath]: configManagerCloudServicesApi.reducer,
  [dataManagerServiceApi.reducerPath]: dataManagerServiceApi.reducer,
  [jobManagerServiceApi.reducerPath]: jobManagerServiceApi.reducer,
  [leadGenServiceApi.reducerPath]: leadGenServiceApi.reducer,
  [n8nWebhookApi.reducerPath]: n8nWebhookApi.reducer,
  [emptyRagServerServicesApi.reducerPath]: emptyRagServerServicesApi.reducer,
  [emptySpeak2MeServicesApi.reducerPath]: emptySpeak2MeServicesApi.reducer,
};
export const apiMiddlewares = [
  configManagerCloudServicesApi.middleware,
  dataManagerServiceApi.middleware,
  jobManagerServiceApi.middleware,
  leadGenServiceApi.middleware,
  n8nWebhookApi.middleware,
  emptyRagServerServicesApi.middleware,
  emptySpeak2MeServicesApi.middleware,
];
